// grubun paylaşma kancası (iskelet/paylas.mjs, PAYLAS_BETIGI); ön izleme kopyası
// paylaşma kancası: kanonik adres, cihazın paylaşma penceresi, yedi ağ, kopyalama..
(function () {
  var bloklar = document.querySelectorAll("[data-paylas]");
  if (!bloklar.length) return;
  var k = document.querySelector('link[rel="canonical"]');
  var genel = k ? k.href : location.href.split("#")[0].split("?")[0];
  var og = document.querySelector('meta[property="og:image"]');
  bloklar.forEach(function (b) {
    var url = b.getAttribute("data-adres") ? new URL(b.getAttribute("data-adres"), genel).href : genel;
    var metin = b.getAttribute("data-metin") || document.title;
    var gorsel = b.getAttribute("data-gorsel") ? new URL(b.getAttribute("data-gorsel"), genel).href : (og ? og.content : "");
    var not = b.querySelector(".paylas-not");
    function soyle(m) { if (!not) return; not.textContent = m; clearTimeout(soyle.z); soyle.z = setTimeout(function () { not.textContent = ""; }, 4000); }
    function kopyala() {
      if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(url);
      window.prompt("", url); return Promise.resolve();
    }
    var E = encodeURIComponent, adresler = {
      whatsapp: "https://wa.me/?text=" + E(metin + " " + url),
      linkedin: "https://www.linkedin.com/sharing/share-offsite/?url=" + E(url),
      x: "https://x.com/intent/post?text=" + E(metin) + "&url=" + E(url),
      facebook: "https://www.facebook.com/sharer/sharer.php?u=" + E(url),
      pinterest: "https://www.pinterest.com/pin/create/button/?url=" + E(url) + "&description=" + E(metin) + (gorsel ? "&media=" + E(gorsel) : ""),
      telegram: "https://t.me/share/url?url=" + E(url) + "&text=" + E(metin)
    };
    Object.keys(adresler).forEach(function (a) { var x = b.querySelector(".paylas-" + a); if (x) x.href = adresler[a]; });
    var yerel = b.querySelector(".paylas-yerel");
    if (yerel) yerel.addEventListener("click", function () {
      if (navigator.share) { navigator.share({ title: document.title, text: metin, url: url }).catch(function () {}); return; }
      soyle(b.getAttribute("data-sec")); var ilk = b.querySelector(".paylas-simgeler a"); if (ilk) ilk.focus();
    });
    var ig = b.querySelector(".paylas-instagram");
    if (ig) { ig.href = "https://www.instagram.com/"; ig.addEventListener("click", function (o) {
      o.preventDefault();
      if (navigator.share) { navigator.share({ title: document.title, text: metin, url: url }).catch(function () {}); return; }
      kopyala().then(function () { soyle(b.getAttribute("data-instagram")); window.open("https://www.instagram.com/", "_blank", "noopener"); }).catch(function () {});
    }); }
    var h = b.querySelector(".paylas-hikaye a");
    var hv = null, hal = function () { return hv || (hv = fetch(h.href).then(function (r) { if (!r.ok) throw r; return r.blob(); })); };
    if (h && navigator.canShare && window.File && window.fetch) h.addEventListener("pointerdown", hal); // dokunur dokunmaz alınır; paylaşma penceresi parmak kalkınca açılır
    if (h) h.addEventListener("click", function (o) {
      if (!navigator.canShare || !window.File || !window.fetch) return;
      o.preventDefault();
      hal().then(function (v) {
        var dosya = new File([v], h.href.split("/").pop(), { type: v.type || "image/jpeg" });
        if (navigator.canShare({ files: [dosya] })) return navigator.share({ files: [dosya], text: metin + " " + url });
        location.href = h.href;
      }).catch(function (x) { if (!x || x.name !== "AbortError") location.href = h.href; });
    });
    var c = b.querySelector(".paylas-kopyala");
    if (c) c.addEventListener("click", function () {
      kopyala().then(function () {
        c.textContent = c.getAttribute("data-tamam");
        setTimeout(function () { c.textContent = c.getAttribute("data-ilk"); }, 2400);
      }).catch(function () {});
    });
    b.hidden = false;
  });
})();
